import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { FC, useState } from 'react';
import { Box, Collapse, Flex, Group, ThemeIcon, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useTranslation } from '@/i18n/client';
import classes from './LinksGroup.module.css';

interface LinksGroupProps {
  icon?: FC<any>;
  label: string;
  link: string;
  links?: { label: string; link: string; noPrefetch?: boolean | undefined }[];
}

export function LinksGroup({ icon: Icon, label, links, link }: LinksGroupProps) {
  const { push } = useRouter();
  const { t, lng } = useTranslation('links');
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(false);
  const items = (hasLinks ? links : []).map((link) => (
    <Link
      className={classes.link}
      href={link?.noPrefetch ? link.link : `/${lng}${link.link}`}
      key={link.label}
      prefetch={link?.noPrefetch ? false : 'auto'}
    >
      {t(link.label)}
    </Link>
  ));

  return (
    <>
      <UnstyledButton
        onClick={() => {
          if (hasLinks) {
            setOpened((o) => !o);
          } else {
            push(link);
          }
        }}
        className={classes.control}
      >
        <Group justify='space-between' gap={0}>
          <Flex align='center'>
            <ThemeIcon variant='light' size={30}>
              {Icon && <Icon size={18} />}
            </ThemeIcon>
            <Box ml='md'>{t(label)}</Box>
          </Flex>
          {hasLinks && (
            <IconChevronRight
              className={classes.chevron}
              stroke={1.5}
              size={16}
              style={{ transform: opened ? 'rotate(-90deg)' : 'none' }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  );
}
